module.exports = __webpack_public_path__ + "static/c5dcfcf4cd7e0bcabd7260c933798b89.png";